import { UPDATEDEPARTMENT_FAIL, UPDATEDEPARTMENT_SUCCESS } from '../actionTypes';

const initialState = {
	user: null
};

const updateDepartmentReducer = (state = initialState, action) => {
	switch (action.type) {
		case UPDATEDEPARTMENT_SUCCESS:
			return {
				...state,
				isLoggedIn: true,
				user: action.payload.user,
			};
		case UPDATEDEPARTMENT_FAIL:
			return {
				...state,
				isLoggedIn: false,
				user: null,
			};
		default:
			break;
	}
	return state;
};

export default updateDepartmentReducer;
